import React from 'react'
import { useNavigate } from 'react-router-dom'
import Cookies from 'js-cookie'
import {
  CDropdown,
  CDropdownDivider,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from '@coreui/react-pro'
import { cilAccountLogout, cilChevronBottom, cilUser } from '@coreui/icons'
import CIcon from '@coreui/icons-react'

// helpers
import Axios from '../../helpers/axios'
import { getFullName, getEmailUser } from '../../helpers/text-format'

const getInitials = (name) => {
  const words = (name || '').trim().split(/\s+/).filter(Boolean)
  const letters = words.slice(0, 2).map((word) => word.charAt(0).toUpperCase()).join('')
  return letters || '?'
}

const AppHeaderDropdown = () => {
  const navigate = useNavigate()
  const token = Cookies.get("ut");
  const user = JSON.parse(localStorage.getItem("user"))
  const fullName = getFullName(user?.profile ? user?.profile : user?.username)
  const email = getEmailUser(user)
  const role = user?.role_user?.toUpperCase()

  const handleLogout = () => {
    Axios({
      method: 'post',
      url: '/api/sso/v1/users/logout'
    })
      .then(() => {
        if (token) {
          document.cookie = `ut=${token}; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        }
        Cookies.remove('ut', { path: '/', secure: true });
        localStorage.removeItem("user")
        localStorage.removeItem("general_setting")
        navigate('/login')
      })
      .catch((err) => {
        console.error(err)
      })
  }

  return (
    <CDropdown variant="nav-item" className="header-user">
      <CDropdownToggle caret={false} className="header-user-toggle">
        <span className="header-user-avatar">{getInitials(fullName)}</span>
        <span className="header-user-meta">
          <span className="header-user-name-row">
            <span className="header-user-name">{fullName}</span>
            {role && <span className="header-role-badge">{role}</span>}
          </span>
          <span className="header-user-email">{email}</span>
        </span>
        <CIcon icon={cilChevronBottom} className="header-user-caret" />
      </CDropdownToggle>
      <CDropdownMenu className="header-user-menu">
        <div className="header-user-menu-head">
          <span className="header-user-avatar header-user-avatar-lg">{getInitials(fullName)}</span>
          <span className="header-user-meta">
            <span className="header-user-name-row">
              <span className="header-user-name">{fullName}</span>
              {role && <span className="header-role-badge">{role}</span>}
            </span>
            <span className="header-user-email">{email}</span>
          </span>
        </div>
        <CDropdownDivider />
        <CDropdownItem onClick={() => navigate('/my-profile')}>
          <CIcon icon={cilUser} className="me-2" />
          My Profile
        </CDropdownItem>
        <CDropdownItem onClick={() => handleLogout()}>
          <CIcon icon={cilAccountLogout} className="me-2" />
          Log Out
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  )
}

export default AppHeaderDropdown
